// import React, { useState, useEffect, useRef } from "react";
// import "./tableStyle.css";
// import {
//   reportsApi,
//   exportDoPendingForBillExcel,
// } from "../../Services/Services";
// import { Col, Input, Button, Radio, Form, Select, message } from "antd";
// import { useReactToPrint } from "react-to-print";
// import { FaFilePdf, FaFileExcel } from "react-icons/fa";
// import * as XLSX from "xlsx"; // Import xlsx library
// import { Link } from "react-router-dom";
// import InfiniteScroll from "react-infinite-scroll-component";
// import { debounce } from "../util.js";

// const { Option } = Select;

// export default function DoPendingForBillReports({ onChange }) {
//   const currentYear = new Date().getFullYear();
//   const years = Array.from({ length: currentYear - 2022 }, (_, i) => 2023 + i);
//   const [selectedYear, setSelectedYear] = useState(currentYear);
//   const [searchParty, setSearchParty] = useState("");
//   const [searchDoNo, setSearchDoNo] = useState("");
//   const [deliveryOrder, setDeliveryOrder] = useState([]);
//   const [orderList, setOrderList] = useState([]);
//   const [offset, setOffset] = useState(0);
//   const [limit] = useState(50); // batch size
//   const [hasMore, setHasMore] = useState(true);
//   const [liftingStatus, setliftingStatus] = useState(""); 
//   const [form] = Form.useForm();
//   const [isExporting, setIsExporting] = useState(false);

//   const getYearsArray = (startYear, endYear) => {
//     const years = [];
//     for (let year = startYear; year <= endYear; year++) {
//       years.push(year);
//     }
//     return years;
//   };

//   useEffect(() => {
//     resetAndLoad();
//   }, [selectedYear]);

//   const resetAndLoad = async (partyName = searchParty, doNo = searchDoNo) => {
//     setOffset(0);
//     setHasMore(true);
//     const response = await fetchData(
//       0,
//       selectedYear,
//       partyName,
//       doNo,
//       liftingStatus
//     );
//     if (response) {
//       setDeliveryOrder(response);
//       setOrderList(response);
//       setOffset(limit);
//     }
//   };

//   // ✅ CORRECT
// const fetchData = async (
//   offset,
//   year = selectedYear,
//   partyName = searchParty,
//   doNo = searchDoNo,
//   status = liftingStatus  
// ) => {
//   const response = await reportsApi({
//     report_name: "do_pending_for_bill",
//     com_name: localStorage.getItem("com_name"),
//     year,
//     client_name: partyName,
//     do_no: doNo,
//     lifting_status: status,  
//     offset,
//     limit,
//   });

//   return response.results;
// };

//   const debouncedSearch = useRef(
//     debounce((partyName, doNo) => {
//       resetAndLoad(partyName, doNo);
//     }, 1000)
//   ).current;

//   const loadMoreData = async () => {
//     if (!hasMore) return;
//     const newData = await fetchData(offset);

//     if (newData.length > 0) {
//       setDeliveryOrder((prev) => [...prev, ...newData]);
//       setOrderList((prev) => [...prev, ...newData]);
//       setOffset(offset + limit);
//     } else {
//       setHasMore(false);
//     }
//   };

//   const handleValuesChange = (changedValues, allValues) => {
//     const filteredData = orderList.filter(
//       (item) =>
//         item.client_name
//           .toLowerCase()
//           .includes((allValues.client_name || "").toLowerCase()) &&
//         item.do_no.toLowerCase().includes((allValues.do_no || "").toLowerCase())
//     );

//     setDeliveryOrder(filteredData);
//   };

// const handleLiftingStatusChange = async (e) => {
//   const val = e.target.value; 
//   setliftingStatus(val);
//   setOffset(0);
//   setHasMore(true);
//   const response = await fetchData(0, selectedYear, searchParty, searchDoNo, val);
//   if (response) {
//     setDeliveryOrder(response);
//     setOrderList(response);
//     setOffset(limit);
//   }
// };


//   const componentRef = useRef();
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//   });

//   const handleExportToExcel = async () => {
//     setIsExporting(true);

//     try {
//       // Show loading message
//       const hideLoading = message.loading("Generating Excel file...", 0);

//       // Prepare params
//       const params = {
//         com_name: localStorage.getItem("com_name"),
//         year: selectedYear,
//         client_name: searchParty,
//         do_no: searchDoNo,
//         lifting_status: liftingStatus,
//         user_type: localStorage.getItem("user_type"),
//         lifter_id: localStorage.getItem("user_id"),
//       };

//       // Call export API
//       const result = await exportDoPendingForBillExcel(params);

//       // Hide loading
//       hideLoading();

//       if (result.success) {
//         // Create blob from response data
//         const blob = new Blob([result.data], {
//           type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         });

//         // Create download link
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;

//         // Generate filename with timestamp
//         const timestamp = new Date()
//           .toISOString()
//           .replace(/[:.]/g, "-")
//           .slice(0, -5);
//         link.download = `Pending_For_Bill_${selectedYear}_${timestamp}.xlsx`;

//         // Trigger download
//         document.body.appendChild(link);
//         link.click();

//         // Cleanup
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);

//         // Success message
//         message.success("Excel file downloaded successfully!");
//       } else {
//         // Error message
//         message.error(
//           result.error?.message ||
//             "Failed to export Excel file. Please try again."
//         );
//       }
//     } catch (error) {
//       console.error("Error in handleExportToExcel:", error);
//       message.error("An unexpected error occurred. Please try again.");
//     } finally {
//       setIsExporting(false);
//     }
//   };

//   const formateDate = (date) => {
//     const [year, month, day] = date.split("-");
//     const formattedDate = `${day}-${month}-${year}`;
//     return formattedDate;
//   };

//   return (
//     <div>
//       <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
//         <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 m-auto px-5 sm:w-[90%] md:w-[100%] mb-4">
//           {/* Year Selector */}
//           <Col>
//             <label className="font-semibold text-gray-700 block">
//               Select Year
//             </label>
//             <Select
//               value={selectedYear}
//               onChange={(value) => {
//                 setSelectedYear(value);
//                 resetAndLoad(); // backend call with new year
//               }}
//               size="middle"
//               style={{
//                 width: "100%",
//                 borderRadius: "8px",
//                 height: "35px",
//                 fontSize: "14px",
//                 marginTop: "4px",
//               }}
//               dropdownStyle={{
//                 borderRadius: "8px",
//                 fontSize: "14px",
//               }}
//               placeholder="Select Year"
//               optionFilterProp="children"
//               showSearch
//             >
//               {years.map((year) => (
//                 <Option key={year} value={year}>
//                   {year}
//                 </Option>
//               ))}
//             </Select>
//           </Col>

//           {/* DO No */}
//           <Col>
//             <label className="font-semibold text-gray-700 mb-1 block">
//               Search By Do No.
//             </label>
//             <Form.Item name="do_no" style={{ marginBottom: 0 }}>
//               <Input
//                 placeholder="Search by DO No."
//                 value={searchDoNo}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setSearchDoNo(value);
//                   debouncedSearch(searchParty, value);
//                 }}
//                 style={{
//                   width: "100%",
//                   padding: "6px 10px",
//                   borderRadius: "6px",
//                   border: "1px solid #ccc",
//                   transition: "0.2s",
//                 }}
//               />
//             </Form.Item>
//           </Col>

//           {/* Party Name */}
//           <Col>
//             <label className="font-semibold text-gray-700 mb-1 block">
//               Search By Party Name
//             </label>
//             <Form.Item name="client_name" style={{ marginBottom: 0 }}>
//               <Input
//                 placeholder="Search by Party Name"
//                 value={searchParty}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setSearchParty(value);
//                   debouncedSearch(value, searchDoNo);
//                 }}
//                 style={{
//                   width: "100%",
//                   padding: "6px 10px",
//                   borderRadius: "6px",
//                   border: "1px solid #ccc",
//                   transition: "0.2s",
//                 }}
//               />
//             </Form.Item>
//           </Col>

//           {/* Lifting Status */}
//           <Col>
//             <label className="font-semibold text-gray-700 mb-1 block">
//               Lifting Status
//             </label>
//             <Radio.Group
//               onChange={handleLiftingStatusChange}
//               value={liftingStatus}
//               buttonStyle="solid"
//             >
//               <Radio value="pending">Pending</Radio>
//               <Radio value="complete">Complete</Radio>
//               <Radio value="">All</Radio>
//             </Radio.Group>
//           </Col>

//           {/* Buttons */}
//           <Col className="flex items-center space-x-6">
//             <Button
//               style={{
//                 backgroundColor: "#151B54",
//                 color: "white",
//                 fontWeight: 600,
//               }}
//             >
//               <FaFilePdf />
//             </Button>
//             <Button
//               onClick={handleExportToExcel}
//               style={{
//                 backgroundColor: "green",
//                 color: "white",
//                 fontWeight: 600,
//               }}
//             >
//               <FaFileExcel />
//             </Button>
//           </Col>
//         </div>
//       </Form>

//       <div
//         id="scrollableDiv"
//         style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}
//         ref={componentRef}
//       >
//         <table id="my-table" className="w-full">
//           <thead className="bg-[#151B54] w-full text-white">
//             <tr>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Sr. No
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Id
//               </th>

//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Party Name
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                 Do No.
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                 Mines Name
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 DO Start Date
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 DO End Date
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Total Qty
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Dispatch Qty
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Balance Qty
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Debit Amt
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Credit Amt
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Balace Amt
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Freight Amt
//               </th>

//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Lifting Status
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Leps/Sell
//               </th>
//               <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
//                 Bill
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {deliveryOrder.map((e, index) => (
//               <tr key={e.id}>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {index + 1}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.id}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.client_name}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   <Link to={`/do-view/${e.id}`}>
//                     <u style={{ fontWeight: "600", color: "blue" }}>
//                       {e.do_no}
//                     </u>
//                   </Link>
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.mines_name}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {formateDate(e.do_start_date)}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {formateDate(e.do_end_date)}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.quantity}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.dis_qty.toFixed(3)}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.rem_qty.toFixed(3)}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.total_advance_paid}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.advance_amt}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {parseFloat(e.total_advance_paid) - parseFloat(e.advance_amt)}
//                 </td>

//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.paid_amt}
//                 </td>

//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.rem_qty != 0 ? "Pending" : "Complete"}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.is_sell || e.is_leps ? (
//                     <>
//                       {e.is_sell ? (
//                         <>Sell - {e.sell_qty.toFixed(3)}</>
//                       ) : (
//                         <>Leps - {e.leps_qty.toFixed(3)}</>
//                       )}
//                     </>
//                   ) : (
//                     ""
//                   )}
//                 </td>
//                 <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
//                   {e.is_bill ? "Yes" : "No"}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         <InfiniteScroll
//           dataLength={deliveryOrder.length}
//           next={loadMoreData}
//           hasMore={hasMore}
//           loader={
//             deliveryOrder.length > 0 && hasMore ? (
//               <div style={{ textAlign: "center", padding: "10px" }}>
//                 Loading...
//               </div>
//             ) : null
//           }
//           scrollableTarget="scrollableDiv"
//         />
//         {/* </InfiniteScroll> */}
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef, useCallback } from "react";
import "./tableStyle.css";
import {
  reportsApi,
  exportDoPendingForBillExcel,
} from "../../Services/Services";
import { Col, Input, Button, Radio, Form, Select, message } from "antd";
import { useReactToPrint } from "react-to-print";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "../util.js";

const { Option } = Select;

export default function DoPendingForBillReports({ onChange }) {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2022 }, (_, i) => 2023 + i);
  
  // State
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [searchParty, setSearchParty] = useState("");
  const [searchDoNo, setSearchDoNo] = useState("");
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(50);
  const [hasMore, setHasMore] = useState(true);
  const [liftingStatus, setLiftingStatus] = useState(""); // ✅ Fixed naming
  const [isExporting, setIsExporting] = useState(false);

  const [form] = Form.useForm();
  const componentRef = useRef();

  // ✅ Fixed: Parameter naming conflict resolved
  const fetchData = useCallback(async (
    fetchOffset,
    year = selectedYear,
    partyName = searchParty,
    doNo = searchDoNo,
    status = liftingStatus
  ) => {
    try {
      const response = await reportsApi({
        report_name: "do_pending_for_bill",
        com_name: localStorage.getItem("com_name"),
        year,
        client_name: partyName,
        do_no: doNo,
        lifting_status: status,
        offset: fetchOffset,
        limit,
      });
      return response.results || [];
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to fetch data");
      return [];
    }
  }, [selectedYear, searchParty, searchDoNo, liftingStatus, limit]);

  // ✅ Fixed: Proper useCallback with dependencies
  const resetAndLoad = useCallback(async (
    partyName = searchParty, 
    doNo = searchDoNo,
    status = liftingStatus
  ) => {
    setOffset(0);
    setHasMore(true);
    const response = await fetchData(0, selectedYear, partyName, doNo, status);
    if (response && response.length > 0) {
      setDeliveryOrder(response);
      setOrderList(response);
      setOffset(limit);
    } else {
      setDeliveryOrder([]);
      setOrderList([]);
      setHasMore(false);
    }
  }, [selectedYear, searchParty, searchDoNo, liftingStatus, limit, fetchData]);

  useEffect(() => {
    resetAndLoad();
  }, [selectedYear]); 

  // ✅ Debounced search
  const debouncedSearch = useRef(
    debounce((partyName, doNo) => {
      resetAndLoad(partyName, doNo);
    }, 1000)
  ).current;

  const handleLiftingStatusChange = async (e) => {
    const val = e.target.value;
    setLiftingStatus(val);
    setOffset(0);
    setHasMore(true);
    const response = await fetchData(0, selectedYear, searchParty, searchDoNo, val);
    if (response && response.length > 0) {
      setDeliveryOrder(response);
      setOrderList(response);
      setOffset(limit);
    } else {
      setDeliveryOrder([]);
      setOrderList([]);
      setHasMore(false);
    }
  };

  const loadMoreData = async () => {
    if (!hasMore) return;
    const newData = await fetchData(offset);

    if (newData && newData.length > 0) {
      setDeliveryOrder((prev) => [...prev, ...newData]);
      setOrderList((prev) => [...prev, ...newData]);
      setOffset((prev) => prev + limit);
    } else {
      setHasMore(false);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleExportToExcel = async () => {
    setIsExporting(true);

    try {
      const hideLoading = message.loading("Generating Excel file...", 0);

      const params = {
        com_name: localStorage.getItem("com_name"),
        year: selectedYear,
        client_name: searchParty,
        do_no: searchDoNo,
        lifting_status: liftingStatus,
        user_type: localStorage.getItem("user_type"),
        lifter_id: localStorage.getItem("user_id"),
      };

      const result = await exportDoPendingForBillExcel(params);
      hideLoading();

      if (result.success) {
        const blob = new Blob([result.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const timestamp = new Date()
          .toISOString()
          .replace(/[:.]/g, "-")
          .slice(0, -5);
        link.download = `Pending_For_Bill_${selectedYear}_${timestamp}.xlsx`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        message.success("Excel file downloaded successfully!");
      } else {
        message.error(
          result.error?.message ||
            "Failed to export Excel file. Please try again."
        );
      }
    } catch (error) {
      console.error("Error in handleExportToExcel:", error);
      message.error("An unexpected error occurred. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  // ✅ Fixed: Safe date formatting
  const formateDate = (date) => {
    if (!date) return "N/A";
    try {
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    } catch (error) {
      return "Invalid Date";
    }
  };

  return (
    <div>
      <Form form={form} layout="vertical">
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 m-auto px-5 sm:w-[90%] md:w-[100%] mb-4">
          {/* Year Selector */}
          <Col>
            <label className="font-semibold text-gray-700 block">
              Select Year
            </label>
            <Select
              value={selectedYear}
              onChange={(value) => setSelectedYear(value)}
              size="middle"
              style={{
                width: "100%",
                borderRadius: "8px",
                height: "35px",
                fontSize: "14px",
                marginTop: "4px",
              }}
              placeholder="Select Year"
              showSearch
            >
              {years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Col>

          {/* DO No */}
          <Col>
            <label className="font-semibold text-gray-700 mb-1 block">
              Search By Do No.
            </label>
            <Input
              placeholder="Search by DO No."
              value={searchDoNo}
              onChange={(e) => {
                const value = e.target.value;
                setSearchDoNo(value);
                debouncedSearch(searchParty, value);
              }}
              style={{
                width: "100%",
                padding: "6px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
          </Col>

          {/* Party Name */}
          <Col>
            <label className="font-semibold text-gray-700 mb-1 block">
              Search By Party Name
            </label>
            <Input
              placeholder="Search by Party Name"
              value={searchParty}
              onChange={(e) => {
                const value = e.target.value;
                setSearchParty(value);
                debouncedSearch(value, searchDoNo);
              }}
              style={{
                width: "100%",
                padding: "6px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
          </Col>

          {/* Lifting Status */}
          <Col>
            <label className="font-semibold text-gray-700 mb-1 block">
              Lifting Status
            </label>
            <Radio.Group
              onChange={handleLiftingStatusChange}
              value={liftingStatus}
              buttonStyle="solid"
            >
              <Radio value="pending">Pending</Radio>
              <Radio value="complete">Complete</Radio>
              <Radio value="">All</Radio>
            </Radio.Group>
          </Col>

          {/* Buttons */}
          <Col className="flex items-center space-x-6">
            <Button
              onClick={handlePrint}
              style={{
                backgroundColor: "#151B54",
                color: "white",
                fontWeight: 600,
              }}
            >
              <FaFilePdf />
            </Button>
            <Button
              onClick={handleExportToExcel}
              loading={isExporting}
              disabled={isExporting}
              style={{
                backgroundColor: isExporting ? "#ccc" : "green",
                color: "white",
                fontWeight: 600,
              }}
            >
              <FaFileExcel />
            </Button>
          </Col>
        </div>
      </Form>

      <div
        id="scrollableDiv"
        style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}
        ref={componentRef}
      >
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Id
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Party Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Do No.
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Mines Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                DO Start Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                DO End Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Total Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Dispatch Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balance Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Debit Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Credit Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balance Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Freight Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Lifting Status
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Leps/Sell
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Bill
              </th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr key={e.id}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.id}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.client_name || 'N/A'}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.do_no}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.mines_name || 'N/A'}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.do_start_date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.do_end_date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.quantity || 0).toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.dis_qty || 0).toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.rem_qty || 0).toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.total_advance_paid || 0).toFixed(2)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.advance_amt || 0).toFixed(2)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(parseFloat(e.total_advance_paid || 0) - parseFloat(e.advance_amt || 0)).toFixed(2)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.paid_amt || 0).toFixed(2)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {(e.rem_qty || 0) !== 0 ? "Pending" : "Complete"}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.is_sell ? `Sale - ${(e.sell_qty || 0).toFixed(3)}` : 
                   e.is_leps ? `Leps - ${(e.leps_qty || 0).toFixed(3)}` : ''}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.is_bill ? "Yes" : "No"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <InfiniteScroll
          dataLength={deliveryOrder.length}
          next={loadMoreData}
          hasMore={hasMore}
          loader={
            deliveryOrder.length > 0 && hasMore ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                Loading...
              </div>
            ) : null
          }
          scrollableTarget="scrollableDiv"
        />
      </div>
    </div>
  );
}